<template>
  <modal
    class="new-board-modal"
    name="NewBoard"
    :maxWidth="350"
    height="auto"
    :adaptive="true"
    :draggable="!isMobileDevice"
    @opened="opened()"
  >
    <div class="edit-modal-window">
      <div class="container">
        <div class="header">
          <span class="edit-modal-window-title">Добавление новой Доски</span>
          <font-awesome-icon class="close-icon" icon="window-close" size="lg" @click="cancel()" />
        </div>
        <textarea-autosize
          ref="title"
          class="title-input"
          v-model="title"
          placeholder="Введите название новой доски"
          :important="true"
          :maxHeight="120"
          @keyup.enter="addBoard"
        />
        <Button class="add green mb-1" title="Добавить" @click="addBoard()" />
        <Button class="cancel red mb-1" title="Отменить" @click="cancel()" />
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NewBoard",
  computed: {
    ...mapGetters(["isMobileDevice"])
  },
  methods: {
    addBoard() {
      if (!this.title) {
        this.cancel();
        return;
      }
      this.$store.dispatch("boards/new", { title: this.title });

      this.cancel();
    },
    cancel() {
      this.title = "";
      this.$modal.hide("NewBoard");
    },
    opened() {
      this.$refs.title.focus();
    }
  },
  data() {
    return {
      title: ""
    };
  }
};
</script>

<style lang="postcss">
.new-board-modal {
  .container {
    margin: 0 0.5em;
    border-radius: 10px;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 10fr auto;
    grid-gap: 0.5em;
    grid-template-areas:
      "header header"
      "inp inp"
      "add can";

    .header {
      margin-top: 0.5em;
      grid-area: header;
      display: grid;
      grid-template-rows: 1fr;
      grid-template-columns: 1fr auto;
      grid-template-areas: "title close";

      .edit-modal-window-title {
        grid-area: title;
      }

      .close-icon {
        grid-area: close;
      }
    }
  }

  .title-input {
    padding: 5px;
    height: 1.5em;
    font-size: 20px !important;
    font-weight: 700;
  }

  .title-input {
    grid-area: inp;
  }

  .add {
    grid-area: add;
  }

  .cancel {
    grid-area: can;
  }
}
</style>
